import ActiveItemsCard from "../ActiveItemsCard";

export const AutomateCloudWasteCard = ({
  cloudFlowsCount,
  totalPotentialSavings,
}: {
  cloudFlowsCount: number;
  totalPotentialSavings: number;
}) => (
  <ActiveItemsCard
    title="Automate cloud waste"
    value={cloudFlowsCount}
    trend={`Possible CloudFlow automation${cloudFlowsCount > 0 ? "" : "s"}`}
    dataIcon="suggestion"
    trendColor="success.main"
    cloudCostsAtRisk={totalPotentialSavings}
    buttonLink="./optimize/insights"
  />
);
